import React from 'react';
import difference from 'lodash.difference';
import * as S from '@xstyled/system';
import { compose, createSystemComponent, th, backgrounds, basics, borders, color, display, flexboxes, grids, height, maxHeight, maxWidth, minHeight, minWidth, positioning, space, typography, verticalAlign, width, margin, marginBottom, marginLeft, marginRight, marginTop, mx, my } from '@xstyled/system';

var FORMIK_META_PROPS = /*#__PURE__*/Object.freeze(['error', 'initialError', 'initialTouched', 'initialValue', 'setError', 'setTouched', 'setValue', 'touched']);
var CUSTOM_FIELD_PROPS = /*#__PURE__*/Object.freeze(['checkableField', 'focused', 'handleRemoveFile', 'icon', 'iconPlacement', 'isClearable', 'isCreatable', 'isEditable', 'isMultiple', 'isSearchable', 'maxSize', 'minRows', 'popperProps', 'renderItem', 'onCreated']);
var SYSTEM_PROPS = /*#__PURE__*/Object.freeze([backgrounds, basics, borders, color, display, flexboxes, grids, height, maxHeight, maxWidth, minHeight, minWidth, positioning, space, typography, verticalAlign, width]);
var WRAPPER_PROPS = /*#__PURE__*/Object.freeze([margin, marginBottom, marginLeft, marginRight, marginTop, mx, my, positioning, width]);
var system = /*#__PURE__*/compose.apply(void 0, SYSTEM_PROPS);
var wrapperSystem = /*#__PURE__*/compose.apply(void 0, WRAPPER_PROPS);
var componentProps = /*#__PURE__*/difference(system.meta.props, wrapperSystem.meta.props).map(function (prop) {
  return S[prop];
}).filter(function (prop) {
  return prop;
});
var componentSystem = /*#__PURE__*/compose.apply(void 0, componentProps);

// Remove (final) field props from DOM
var filterFieldComponent = function filterFieldComponent(Component, omitProps) {
  if (omitProps === void 0) {
    omitProps = [];
  }
  return filterComponent(Component, [].concat(omitProps, CUSTOM_FIELD_PROPS, FORMIK_META_PROPS));
};

// Remove supplied props from DOM
var filterComponent = function filterComponent(Component, omitProps) {
  if (omitProps === void 0) {
    omitProps = [];
  }
  var unallowedProps = {
    meta: {
      props: ['connected'].concat(omitProps, system.meta.props)
    }
  };
  return createSystemComponent(React, Component, unallowedProps);
};
var shouldForwardProp = function shouldForwardProp(prop, defaultValidatorFn) {
  return defaultValidatorFn(prop);
};
var themePath = th;

export { componentSystem, filterComponent, filterFieldComponent, shouldForwardProp, system, themePath, wrapperSystem };
